import './Label.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var LabelCSS = _7a468({defaultClassName:'_jjr7jx0-2-0-1',variantClassNames:{disabled:{true:'_jjr7jx1-2-0-1'},required:{true:'_jjr7jx2-2-0-1'}},defaultVariants:{},compoundVariants:[]});